<template>
  <div class="hello">
    <video
        id="intro-video"
        class="intro-video"
        v-show="watchIntro"
        v-bind:src="'static/video/intro-' + this.language + '.mp4'"
        @ended="onVideoEnded()"
        ref="introVideo"></video>
    <div v-show="loading" class="v-center-flex">
      <img v-show="!watchIntro" src="static/img/AR_logo_black.svg" alt="" class="logo">
      <div class="loader">
        <div class="loader-progress-percentage">
          {{loadedPercentage}}%
        </div>
        <div class="loader-progress-bar" v-bind:style="{width: loadedPercentage + '%'}"></div>
      </div>
    </div>
    <div v-if="!loading" class="v-center-flex">
      <img v-show="!watchIntro" src="static/img/AR_logo_black.svg" alt="" class="logo">
      <div class="button"
           @click="onWatchIntro">
        <a href="#"><span v-lang.intro.watch></span></a>
      </div>
      <div
        @click="onEnterSite()"
        v-if="!loading"
        class="enter-site-button">
        <div class="button">
          <a href="#"><span v-lang.intro.skip></span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull'
import $ from 'jquery'
export default {
  name: 'hello',
  data () {
    return {
      loading: true,
      loadedPercentage: 0,
      watchIntro: false
    }
  },
  methods: {
    onEnterSite () {
      $('.initial').removeClass('initial')
      if (this.$route.path === '/') {
        this.$router.push('rooftop')
      }
      if (this.$refs.introVideo) {
        this.$refs.introVideo.pause()
      }
      this.$bus.$emit('enter-site')
      // this.fullScreen()
    },
    fullscreen () {
      if (screenfull.enabled) {
        screenfull.request()
      }
    },
    onWorldLoaded () {
      this.loading = false
    },
    onVideoEnded () {
      this.onEnterSite()
    },
    onLoadingManagerProgress (e) {
      this.loadedPercentage = parseInt(100 * e.loaded / e.total)
    },
    onLoadingManagerStart (e) {
      this.loading = true
    },
    onWatchIntro () {
      // this.fullscreen()
      this.watchIntro = true
      this.$refs.introVideo.play()
    },
    onClickAudioButton () {
      console.log('yo', this.$refs.introVideo)
    }
  },
  mounted () {
    if (this.$route.path === '/intro') {
      this.loading = false
    } else {
      this.$bus.$on('world-loaded', this.onWorldLoaded.bind(this))
      this.$bus.$on('loading-manager-progress', this.onLoadingManagerProgress.bind(this))
      this.$bus.$on('loading-manager-start', this.onLoadingManagerStart.bind(this))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intro-video {
  position: fixed !important;
  z-index: 999;
  top: calc((100vh - (100vw / 16 * 9))/2);
  bottom: 0;
  left: 0;
  right: 0;
  height: auto !important;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: black;
  font-weight: bold;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.hello {
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    padding: 32px;
}

.logo-container {
  margin: 48px auto 32px auto;
}
.logo {
  display: block;
  margin: 0 auto 32px;
  width: 300px;
}
.button {
  transition: all 1s;
  background: white;
  display: inline-block;
  padding: 15px 30px;
  transition: all 1s;
  border: 2.7px solid black;
  margin: 8px;
  width: 150px;
}
.enter-site-button.centered {
  right: 50%;
  bottom: 200px;
  transform: translateX(50%);
}

.enter-site-button.centered .logo {
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/Hello.vue